import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

import { ElementsManager } from './ElementsManager';

export class Controller {
  elementsManager: ElementsManager = new ElementsManager();

  //   protected tlDefaults: gsap.TweenVars = {
  //     // delay: 0.5,
  //     ease: 'power3.out',
  //   };

  //   protected scrollTriggerDefaults: gsap.plugins.ScrollTriggerInstanceVars = {
  //     pin: true,
  //     start: 'top top',
  //     scrub: true,
  //     markers: false,
  //     snap: {
  //       snapTo: 'labels',
  //       duration: { min: 6, max: 10 },
  //       delay: 0.2,
  //       ease: 'power1.inOut',
  //     },
  //   };

  constructor() {
    //this.elementsManager = this.elementsManager;;
    this.bindEvents(); // Add this to bind the resize listener when the instance is created
  }

  // Generic method to initialize animations. Can be overridden by derived classes.
  public init(): void {
    throw new Error('init() method should be implemented in derived classes.');
  }

  // Can add shared methods here, for instance:
  //   protected splitText(target: HTMLElement): void {
  //     new SplitText(target, { type: 'lines', linesClass: 'lineParent' });
  //     new SplitText(target, { type: 'lines', linesClass: 'splittext-line' });
  //     gsap.set('.splittext-line', {
  //       css: {
  //         overflow: 'hidden',
  //         lineHeight: '100%',
  //         willChange: 'transform',
  //         margin: '0 -10px -15px 0',
  //         padding: '0 10px 15px 0',
  //       },
  //     });
  //   }

  public onResize(): void {
    //console.log('onResize() method should be implemented in derived classes.');
    //ScrollTrigger.refresh();
  }
  // Bind event listeners
  protected bindEvents(): void {
    window.addEventListener('resize', this.onResize.bind(this));
  }

  // This method can be called if you ever need to remove the event listeners (e.g., before destroying the instance)
  public unbindEvents(): void {
    window.removeEventListener('resize', this.onResize.bind(this));
  }
}
